import React from "react";
import { sanitizeNbsp } from "@/utils/quillClipboard";

interface ContentViewerProps {
  content: string;
  contentType?: "passage" | "question";
  onTextSelected?: (selectedText: string, rect: DOMRect) => void;
}

const ContentViewer: React.FC<ContentViewerProps> = React.memo(
  ({ content, contentType, onTextSelected }) => {
    const handleTextSelection = () => {
      const selection = window.getSelection();
      if (!selection || selection.isCollapsed) {
        return;
      }

      const selectedText = selection.toString().trim();
      if (!selectedText) {
        return;
      }

      // 선택된 텍스트의 위치 정보를 부모에게 전달
      const range = selection.getRangeAt(0);
      const rect = range.getBoundingClientRect();

      onTextSelected?.(selectedText, rect);
    };

    return (
      <div
        className="quill-content whitespace-pre-wrap text-[18px] text-gray-900 leading-relaxed font-serif font-times [&_img]:block [&_img]:mx-auto cursor-text"
        style={{ fontFamily: '"Times New Roman", Times, serif' }}
        dangerouslySetInnerHTML={{ __html: sanitizeNbsp(content) }}
        onMouseUp={handleTextSelection}
      />
    );
  }
);

export default ContentViewer;
